<div class="flex overflow-auto">
    <table class="w-full text-sm text-left text-gray-500">
        <thead
            class="text-xs text-gray-700 uppercase bg-gray-50 sticky top-0 z-10"
        >
            <tr>
                <ng-template ngFor let-headerColInfo [ngForOf]="headerColsInfo">
                    <th
                        scope="col"
                        class="py-3 px-6"
                        [ngClass]="{ 'align-top': !headerColInfo.filterable }"
                        [style.width]="headerColInfo.widthPercentage + '%'"
                    >
                        <ng-template
                            [ngIf]="headerColInfo.filterable"
                            [ngIfElse]="notFilterableHeader"
                        >
                            <div class="flex flex-col">
                                <ng-template
                                    [ngIf]="headerColInfo.sortable"
                                    [ngIfElse]="notSortableHeader"
                                >
                                    <div class="flex gap-2">
                                        <span>{{
                                            headerColInfo.headerName
                                        }}</span>
                                        <span *ngIf="headerColInfo.sortable">
                                            <zt-icon
                                                [icon]="
                                                    getColumnSortIcon(
                                                        headerColInfo.key
                                                    )
                                                "
                                                (click)="
                                                    onSortClick(headerColInfo)
                                                "
                                                class="hover:cursor-pointer hover:text-teal-400"
                                                [ngClass]="{
                                                    'text-teal-500':
                                                        getColumnSortIcon(
                                                            headerColInfo.key
                                                        ) !==
                                                        ZtIcon.ARROWS_UP_DOWN
                                                }"
                                            ></zt-icon>
                                        </span>
                                    </div>
                                </ng-template>
                                <ng-template #notSortableHeader>
                                    <span>{{ headerColInfo.headerName }}</span>
                                </ng-template>
                                <div
                                    class="zt-filter"
                                    *ngIf="headerColInfo.filterable"
                                >
                                    <zt-filter
                                        [configuration]="
                                            filterConfigurationMap.get(
                                                headerColInfo.key
                                            )
                                        "
                                        (filterChange)="onFilterChange($event)"
                                    ></zt-filter>
                                </div>
                            </div>
                        </ng-template>
                        <ng-template #notFilterableHeader>
                            <ng-template
                                [ngIf]="headerColInfo.sortable"
                                [ngIfElse]="notSortableHeader"
                            >
                                <div class="flex gap-2 items-center">
                                    <span>{{ headerColInfo.headerName }}</span>
                                    <span *ngIf="headerColInfo.sortable">
                                        <zt-icon
                                            [icon]="ZtIcon.ARROWS_UP_DOWN"
                                        ></zt-icon>
                                    </span>
                                </div>
                            </ng-template>
                            <ng-template #notSortableHeader>
                                <span>{{ headerColInfo.headerName }}</span>
                            </ng-template>
                        </ng-template>
                    </th>
                </ng-template>
            </tr>
        </thead>
        <tbody>
            <ng-template [ngIf]="filteredData?.length == 0">
                <tr>
                    No elements found!
                </tr>
            </ng-template>
            <ng-container *ngIf="filteredData?.length != 0">
                <tr
                    *ngFor="
                        let item of filteredData.slice(
                            startIndex,
                            startIndex + nrOfElementsPerPage
                        );
                        index as i
                    "
                >
                    <ng-template
                        ngFor
                        let-headerColInfo
                        [ngForOf]="headerColsInfo"
                    >
                        <ng-container [ngSwitch]="headerColInfo.type">
                            <ng-template [ngSwitchCase]="ZtHeaderTypes.STRING">
                                <ng-template
                                    [ngIf]="!headerColInfo.shouldConcat"
                                    [ngIfElse]="concatableTextCell"
                                >
                                    <td class="py-4 px-6">
                                        {{ toString(headerColInfo, item) }}
                                    </td>
                                </ng-template>
                                <ng-template #concatableTextCell>
                                    <td
                                        class="py-4 px-6"
                                        [title]="toString(headerColInfo, item)"
                                    >
                                        <ng-template
                                            [ngIf]="
                                                isConcated(headerColInfo, item)
                                            "
                                            [ngIfElse]="fullText"
                                        >
                                            <span>
                                                {{
                                                    getConcatDisplayText(
                                                        toString(
                                                            headerColInfo,
                                                            item
                                                        )
                                                    )
                                                }}
                                            </span>
                                            <span
                                                *ngIf="
                                                    showConcatExpandBtn(
                                                        toString(
                                                            headerColInfo,
                                                            item
                                                        )
                                                    )
                                                "
                                                class="text-teal-500 hover:cursor-pointer hover:text-teal-400"
                                                (click)="
                                                    expandText(
                                                        headerColInfo,
                                                        item,
                                                        $event
                                                    )
                                                "
                                            >
                                                Show more
                                            </span>
                                        </ng-template>
                                        <ng-template #fullText>
                                            <span>
                                                {{
                                                    toString(
                                                        headerColInfo,
                                                        item
                                                    )
                                                }}
                                            </span>
                                            <span
                                                *ngIf="
                                                    showConcatExpandBtn(
                                                        toString(
                                                            headerColInfo,
                                                            item
                                                        )
                                                    )
                                                "
                                                class="text-teal-500 hover:cursor-pointer hover:text-teal-400"
                                                (click)="
                                                    clipText(
                                                        headerColInfo,
                                                        item,
                                                        $event
                                                    )
                                                "
                                            >
                                                Show less
                                            </span>
                                        </ng-template>
                                    </td>
                                </ng-template>
                            </ng-template>
                            <ng-template
                                [ngSwitchCase]="ZtHeaderTypes.STRING_VARIANTS"
                            >
                                <td class="py-4 px-6">
                                    {{ toString(headerColInfo, item) }}
                                </td>
                            </ng-template>
                            <ng-template [ngSwitchCase]="ZtHeaderTypes.DATE">
                                <td class="py-4 px-6">
                                    {{
                                        toString(headerColInfo, item)
                                            | date: dateFormat
                                    }}
                                </td>
                            </ng-template>
                            <ng-template [ngSwitchCase]="ZtHeaderTypes.AUDIO">
                                <td
                                    [ngClass]="{
                                        'w-[15%]': getBlob(headerColInfo, item)
                                    }"
                                >
                                    <ng-template
                                        [ngIf]="
                                            !getBlob(headerColInfo, item) &&
                                            !shouldShowControls(
                                                headerColInfo,
                                                item
                                            )
                                        "
                                        [ngIfElse]="audioControl"
                                    >
                                        <zt-button
                                            class="flex items-center justify-center"
                                            [config]="playBtnConfig"
                                            [type]="ZtButtonType.PRIMARY"
                                            (onClick)="
                                                onClickHandler(
                                                    headerColInfo,
                                                    item
                                                )
                                            "
                                        ></zt-button>
                                    </ng-template>
                                    <ng-template #audioControl>
                                        <zt-simple-waveform-viewer
                                            [blob]="
                                                getBlob(headerColInfo, item)
                                            "
                                            [play]="
                                                shouldPlayAudio(
                                                    headerColInfo,
                                                    item
                                                )
                                            "
                                            [showControls]="true"
                                            [showWaveform]="false"
                                            (onFinish)="
                                                stopAudio(headerColInfo, item)
                                            "
                                        ></zt-simple-waveform-viewer>
                                    </ng-template>
                                </td>
                            </ng-template>
                            <ng-template [ngSwitchCase]="ZtHeaderTypes.ACTIONS">
                                <td>
                                    <div class="flex justify-around">
                                        <ng-template
                                            ngFor
                                            let-action
                                            [ngForOf]="
                                                getActions(headerColInfo, item)
                                            "
                                        >
                                            <zt-button
                                                [config]="action.btnConfig"
                                                [type]="action.btnType"
                                                (onClick)="
                                                    onActionClickHandler(
                                                        item,
                                                        action
                                                    )
                                                "
                                            ></zt-button>
                                        </ng-template>
                                    </div>
                                </td>
                            </ng-template>
                        </ng-container>
                    </ng-template>
                </tr>
            </ng-container>
        </tbody>
    </table>
</div>
<div
    class="bg-white py-3 px-4 flex items-center justify-between border-t border-gray-200 sm:px-6"
>
    <div>
        <p class="text-sm text-gray-700">
            Showing
            <span class="font-medium">{{
                filteredData.length == 0 ? 0 : startIndex + 1
            }}</span>
            to
            <span class="font-medium">{{
                startIndex +
                    filteredData.slice(
                        startIndex,
                        startIndex + nrOfElementsPerPage
                    ).length
            }}</span>
            of
            <span class="font-medium">{{ filteredData.length }}</span>
            results.
        </p>
    </div>
    <div class="hidden sm:flex sm:flex-1 sm:items-center sm:justify-end">
        <nav
            class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
            aria-label="Pagination"
        >
            <a
                class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 hover:cursor-pointer"
                (click)="decreasePage()"
            >
                <span class="sr-only">Previous</span>
                <svg
                    class="h-5 w-5"
                    x-description="Heroicon name: mini/chevron-left"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                >
                    <path
                        fill-rule="evenodd"
                        d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z"
                        clip-rule="evenodd"
                    ></path>
                </svg>
            </a>
            <a
                *ngFor="let page of pages; index as i"
                aria-current="page"
                class="z-10 page bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium hover:cursor-pointer"
                [ngClass]="{ '--active': currentPage == i }"
                (click)="switchPage(i)"
            >
                {{ i + 1 }}
            </a>
            <a
                class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 hover:cursor-pointer"
                (click)="increasePage()"
            >
                <span class="sr-only">Next</span>
                <svg
                    class="h-5 w-5"
                    x-description="Heroicon name: mini/chevron-right"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                >
                    <path
                        fill-rule="evenodd"
                        d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                        clip-rule="evenodd"
                    ></path>
                </svg>
            </a>
        </nav>
    </div>
</div>
